module.exports = __webpack_public_path__ + "img/not-found.b9a36669.svg";